import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL, PRICE, REGULAR_PRICE, SAVINGS, TOMES_VALUE, BONUSES_VALUE, TOTAL_VALUE } from '../data/offer';
const volumes = ['Volume 1 — Diagnosi Profonda e Onboarding', 'Volume 2 — Il Nucleo: Riscrivere le Credenze', 'Volume 3 — Dall’intuizione all’azione', 'Volume 4 — Il cliente bloccato ⭐', 'Volume 5 — Chiudere bene', 'Volume 6 — La pratica professionale', '23 schede di lavoro WS-01 → WS-23'];
const bonuses = ['Bonus 1 — Il Caveau delle Prove di Progresso', 'Bonus 2 — Il Kit Trasformazione della Consegna Premium', 'Bonus 3 — Il Protocollo di Emergenza per il Cliente Bloccato', 'Bonus 4 — Il Sistema di Preparazione in 10 Minuti', 'Bonus 5 — Kit Documenti del Coach Professionista'];
const badges = ['Risparmi ' + SAVINGS, 'Pagamento unico', 'Accesso a vita'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-cream" data-id="element-154" data-mp="3vzym6f0q9521">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-155" data-mp="4svttk95ksq8">
        <h2 id="pricing-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-156" data-mp="4v8kqmww2dff">
          Prendi il sistema completo oggi
        </h2>

        <div className="mt-8 rounded-3xl bg-white border-2 border-sage-soft shadow-card p-7 sm:p-10" data-id="element-157" data-mp="eqjzv6c7lmnp">
          <div className="text-center" data-id="element-158" data-mp="3d6uq6n01eg49">
            <p className="font-serif font-bold text-ink text-xl sm:text-2xl leading-snug" data-id="element-159" data-mp="3i7irq2lw6fcq">
              Il Sistema Completo del Coach™ — Edizione Completa
            </p>
            <p className="mt-2 text-ink-soft text-sm sm:text-base" data-id="element-160" data-mp="3n5akeyud25hz">
              Tutto quello che serve per condurre un percorso di coaching
              dall&apos;inizio alla fine
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-6 text-left" data-id="element-161" data-mp="2zhatnyx1uf3e">
            <div data-id="element-162" data-mp="2zf7t4ky9t3kf">
              <p className="text-xs uppercase tracking-[0.14em] font-bold text-sage" data-id="element-163" data-mp="2rglansogvt93">
                I 6 volumi
              </p>
              <ul className="mt-3 space-y-2" data-id="element-164" data-mp="2mgqfve1kmjir">
                {volumes.map(item => <li key={item} className="flex items-start gap-2 text-[14px] text-ink-soft" data-id="element-165" data-mp="315mnxb3mnwjd">
                    <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0 text-vital" aria-hidden="true" data-id="element-166" data-mp="2w7beh1h8vo1o" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-167" data-mp="2ig6j4bkwthx5">
              <p className="text-xs uppercase tracking-[0.14em] font-bold text-terracotta" data-id="element-168" data-mp="2igpvzdvpdg4b">
                I 5 bonus
              </p>
              <ul className="mt-3 space-y-2" data-id="element-169" data-mp="2dfimnadww8vj">
                {bonuses.map(item => <li key={item} className="flex items-start gap-2 text-[14px] text-ink-soft" data-id="element-170" data-mp="3tu0krnizcmtc">
                    <GiftIcon className="w-4 h-4 mt-0.5 flex-shrink-0 text-terracotta" aria-hidden="true" data-id="element-171" data-mp="3ovgyfm0h590g" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-8 rounded-2xl bg-cream border border-cream-dark px-5 py-4 text-sm text-ink-soft text-center" data-id="element-172" data-mp="3ng4t5v6mqcu0">
            I 6 volumi: <strong className="text-ink" data-id="element-173" data-mp="3riredd8sozi8">{TOMES_VALUE}</strong> · I
            5 bonus: <strong className="text-ink" data-id="element-174" data-mp="j26goslm5suf">{BONUSES_VALUE}</strong> ·
            Valore totale:{' '}
            <strong className="text-ink" data-id="element-175" data-mp="nyn41kkzo36g">{TOTAL_VALUE}</strong>
            <span className="block mt-1" data-id="element-176" data-mp="a9338kayxfzs">
              Prezzo regolare:{' '}
              <span className="line-through" data-id="element-177" data-mp="ea56dc80ac71">{REGULAR_PRICE}</span>
            </span>
          </div>

          <div className="mt-7 text-center" data-id="element-178" data-mp="11zr55ykgupei">
            <div className="flex items-end justify-center gap-3" data-id="element-179" data-mp="11yxskgytt5og">
              <span className="font-serif text-2xl text-ink-muted line-through" data-id="element-180" data-mp="16q7k5n3xqj2z">
                {REGULAR_PRICE}
              </span>
              <span className="font-serif font-black text-6xl sm:text-7xl text-terracotta leading-none" data-id="element-181" data-mp="3f8bh6fynv5sg">
                {PRICE}
              </span>
            </div>

            <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-182" data-mp="358szk6683w3k">
              {badges.map(badge => <li key={badge} className="rounded-full bg-sage-tint text-sage border border-sage-soft px-3.5 py-1.5 text-xs sm:text-sm font-semibold" data-id="element-183" data-mp="318iy96tdltv1">
                  {badge}
                </li>)}
            </ul>

            <p className="mt-5 text-xs sm:text-sm text-ink-muted" data-id="element-184" data-mp="3o7otdge668gv">
              Addebito in euro, IVA inclusa dove applicabile.
            </p>

            <CtaButton href={CHECKOUT_URL} className="mt-3 w-full" data-id="element-185" data-mp="3k63j82t0s8ad">
              Sì, voglio Il Sistema Completo del Coach
            </CtaButton>

            <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-ink-soft font-medium" data-id="element-186" data-mp="fsn6w7xsemnz">
              <li className="flex items-center gap-1.5" data-id="element-187" data-mp="1yg6m39u8omuz">
                <LockIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-188" data-mp="23e8740b86w93" />
                Pagamento sicuro
              </li>
              <li className="flex items-center gap-1.5" data-id="element-189" data-mp="27fjx46y0hjht">
                <ZapIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-190" data-mp="27i65u9wn251m" />
                Download immediato
              </li>
              <li className="flex items-center gap-1.5" data-id="element-191" data-mp="2heiz56o9ugvu">
                <ShieldCheckIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-192" data-mp="2hbwrz85am3e5" />
                Garanzia 14 giorni
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}